var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row py-3" }, [
        _c("div", { staticClass: "col-4 paginate-info" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("tables.filters.showingOutOf", {
                  current: _vm.currentListLength,
                  total: _vm.total,
                })
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-8 d-flex flex-row align-items-center justify-content-end",
          },
          [
            _c(
              "a",
              {
                staticClass: "paginate_button previous",
                class: _vm.previousButtonClass,
                on: {
                  click: function ($event) {
                    return _vm.handleIncrementClick(
                      -_vm.limit,
                      _vm.currentPage - 1
                    )
                  },
                },
              },
              [_c("i", { staticClass: "fa fa-chevron-left fa-2x" })]
            ),
            _vm._v(" "),
            _vm._l(_vm.pageNumbers, function (page, index) {
              return _c("div", { key: page, staticClass: "d-flex flex-row" }, [
                _c(
                  "a",
                  {
                    staticClass: "paginate_button",
                    class: _vm.currentPageButtonClass(page),
                    on: {
                      click: function ($event) {
                        return _vm.handlePageClick(page)
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(page) + "\n        ")]
                ),
                _vm._v(" "),
                _vm.showEllipsis(page, index)
                  ? _c("div", { staticClass: "paginate-button-ellipsis" }, [
                      _vm._v("\n          ...\n        "),
                    ])
                  : _vm._e(),
              ])
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "paginate_button next",
                class: _vm.nextButtonClass,
                on: {
                  click: function ($event) {
                    return _vm.handleIncrementClick(
                      _vm.limit,
                      _vm.currentPage + 1
                    )
                  },
                },
              },
              [_c("i", { staticClass: "fa fa-chevron-right fa-2x" })]
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }